import React from "react";
import css from "./HasAttended.module.scss";
import { Chip } from "@mantine/core";
import cx from "classnames";
const HasAttended = ({
  hasAttended,
  source,
  onUpdateHasAttended = () => {},
}) => {
  // `workspace-page-preview` is the narrow right-pane preview shown
  // while the user is in a Zoom call and previewing another meeting.
  // It needs a column layout so the label doesn't overlap the chips.
  const isWorkspace =
    source === "workspace-page" || source === "workspace-page-preview";
  const isCompact = source === "workspace-page-preview";
  return (
    <div
      className={cx(
        css.attend,
        isWorkspace && css.workspace,
        isCompact && css.compact,
      )}
    >
      {isWorkspace && <span>Have you attended?</span>}
      <div className={css.chips}>
        <Chip
          size="xs"
          radius="xl"
          className={css.chip}
          // variant={(hasAttended || hasAttended === undefined) ? "filled" : "light"}
          variant="filled"
          color="blue"
          checked={hasAttended || hasAttended === undefined}
          onClick={() => onUpdateHasAttended(true)}
        >
          Yes
        </Chip>
        <Chip
          size="xs"
          radius="xl"
          className={css.chip}
          variant={hasAttended === false ? "filled" : "light"}
          color="blue"
          checked={hasAttended === false}
          onClick={() => onUpdateHasAttended(false)}
        >
          No
        </Chip>
      </div>
    </div>
  );
};

export default HasAttended;
